var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M336 16H496V496H336V16Z",
    fill: "#E32D3C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M176 16H336V496H176V16Z",
    fill: "#F1C40F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16 16H176V496H16V16Z",
    fill: "#222222"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBe);
export default __webpack_public_path__ + "static/media/BE.5064ddf55f12c1d2f324972009ce2e78.svg";
export { ForwardRef as ReactComponent };